export const OUT_OF_PUS_RESTRICTION = 'OUT_OF_PUS';

export enum RoleLevel {
  ORGANIZATION_USER = 100,
  ORGANIZATION_ADMIN = 1000,
  PLANET_USER = 1999,
  PLANET_ADMIN = 2000,
}

export enum Role {
  ROOT = 2,
  SUPPORT = 8,
  SUPPORT_READ = 9,
}

export const IMPERSONATION_ROLE_IDS: ReadonlySet<number> = new Set([
  Role.ROOT,
  Role.SUPPORT,
  Role.SUPPORT_READ,
]);
